export default {
  ORDER: 'order',
  AUTH_INSTORE: 'authInstore',
  EMAIL: 'email',
  PHONE: 'phone',
  ORDER_HISTORY: 'orderHistory',
  ORDER_DETAILS: 'orderDetails',
  STH_TRACKING: 'sthTracking',
  BOSS_TRACKING: 'bossTracking',
  BODFS_TRACKING: 'bodfsTracking',
  APPLIANCE_ACTION: 'applianceAction',
  ERECEIPTS_SUMMARY: 'eReceiptsSummary',
};
